import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {Messages} from "../../../../Messages";
import {MerchantCheckbox} from "../../../../widget/ui/MerchantCheckbox";
import {LabeledCheckbox} from "../../../../ui/Checkbox";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {authService, userService} from "../../../../../client/connection/Services";
import {BlinkInput} from "../../../../ui/Input";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {iFrameState} from "../../../../services/IFrameState";
import {
     apiUserUpdateNewsletterSubscriptions, MerchantAudienceMemberStore,
     NewsletterSubscriptionUpdateType
} from "../../../../../client/state/merchant/MerchantAudienceMemberStore";
import {authFormService} from "../../../../services/AuthFormService";
import {INLINE_NEWSLETTER_URLS} from "../../../PanelConstants";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {PanelActionButton} from "../../../panel-elements/ActionButton";
import {isSmallScreen} from "../../../../UtilsLib";
import {BASE_PANEL_WIDTH, FLOW_CHECKPOINT, FLOW_TYPE, GATE_TYPE} from "../../../../../blink-sdk/Constants";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {MerchantUserStore} from "../../../../../client/state/merchant/MerchantUserStore";
import {LoadingSpinner} from "../../../../ui/LoadingSpinner";
import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {MerchantAudienceStore} from "../../../../../client/state/merchant/MerchantAudienceStore";
import {
     CONFIRMATION_CODE_TYPES,
     DEFAULT_CONFIRMATION_CODE_TYPE,
     LOGIN_WITH_EMAIL_CODE_URL
} from "../../../../Constants";
import {ApiErrors} from "../../../../../client/connection/ApiErrors";
import {sendFlowCheckpoint} from "../../../flows/FlowController";
import {Toast} from "../../../../ui/Toast.jsx";


export class NewsletterSubscribePanelStyle extends BasePanelPageStyle {
     @styleRuleInherit
     panelPage = {
          maxWidth: `${BASE_PANEL_WIDTH}px !important`,
     };

     @styleRule
     checkbox = {
          marginTop: 12,
          textAlign: "left",
     };

     @styleRule
     message = {
          ...this.themeProps.PANEL_MESSAGE_STYLE,
          marginTop: 16,
          fontSize: 15,
          lineHeight: 22,
          textAlign: () => (isSmallScreen() || iFrameState.gateType === GATE_TYPE.banner) ? "left" : "center",
          ...iFrameState.textStyle,
     };

     @styleRule
     separatorLine = {
          width: "100%",
          height: 0.5,
          background: "#E5E5E5",
          marginTop: 12,
     };

     @styleRule
     button = {
          marginTop: 20,
     };
}

@registerStyle(NewsletterSubscribePanelStyle)
export class NewsletterSubscribePanel extends BasePanelPage {
     fields = null;
     widthValue = 420;

     getDefaultOptions() {
          return {
               ...super.getDefaultOptions(),
               title: () => Messages.newsletterTitle(iFrameMerchantService.getMerchant().getName()),
          };
     }

     renderNewsletters() {
          const {styleSheet} = this;
          const newsletters = MerchantAudienceStore.all();

          if (!this.fields) {
               this.fields = {};
               for (const newsletter of newsletters) {
                    this.fields[newsletter.id] = true;
               }
          }
          if (newsletters.length === 1) {
               return <div className={styleSheet.message}>{newsletters[0].name}</div>;
          }
          return newsletters.map(({name, id}) => <LabeledCheckbox CheckboxClass={MerchantCheckbox} label={name} initialValue={this.fields[id]}
                                                                  className={styleSheet.checkbox}
                                                                  onChange={enabled => {
                                                                       this.fields[id] = enabled;
                                                                       this.redraw();
                                                                  }}/>);
     }

     render() {
          const {styleSheet} = this;
          const newsletters = MerchantAudienceStore.all();
          const merchantName = iFrameMerchantService.getMerchant().getName();
          const merchantUser = MerchantUserStore.getByUserAndMerchant(userService.getUserId(), iFrameMerchantService.merchantId);

          return [
               <div className={styleSheet.leftAlign}>{authService.isAuthenticated() ? (
                   newsletters.length === 1 ?
                       Messages.newsletterSubscribeSingleNewsletterAuthenticatedTitle :
                       Messages.newsletterSubscribeMultipleNewsletterAuthenticatedTitle
               ) : (
                   newsletters.length === 1 ?
                       Messages.newsletterSubscribeSingleNewsletterUnauthenticatedTitle :
                       Messages.newsletterSubscribeMultipleNewsletterUnauthenticatedTitle
               )}</div>,
               authService.isAuthenticated() ? null :
                   <BlinkInput ref="emailInput" inputAttributes={{type: "email"}} label={Messages.emailAddress} error={this.emailError}
                              onFocus={() => this.clearErrors()}/>,
               this.renderNewsletters(),
               newsletters.length === 1 ? null : [
                         <div className={styleSheet.separatorLine}/>,
                         <LabeledCheckbox CheckboxClass={MerchantCheckbox} className={styleSheet.checkbox}
                                          label={Messages.allowPromotionalEmailsFromMerchant(merchantName)}
                                          initialValue={!merchantUser || merchantUser.canReceivePromotionalEmails}
                                          ref="promotionalEmailsCheckbox"/>,
                   ],
               <PanelActionButton label={Messages.subscribeToNewsletter} className={styleSheet.button}
                                  onClick={() => this.subscribeToNewsletter(this.emailInput?.getValue() || userService.getUserEmail(), this.promotionalEmailsCheckbox?.getValue())}/>,
               !authService.isAuthenticated() ? null :
                   <MessageElement className={styleSheet.message} message={newsletters.length === 1 ?
                       Messages.newsletterEmailDescription(userService.getUserEmail()) :
                       Messages.newslettersEmailDescription(userService.getUserEmail())} />,
          ];
     }

     clearErrors() {
          this.emailError = null;
          this.redraw();
     }

     async subscribeToNewsletter(emailAddress, canReceivePromotionalEmails) {
          const {merchantId} = iFrameMerchantService;
          const merchantUser = MerchantUserStore.getByUserAndMerchant(userService.getUserId(), merchantId);
          const updatedCanReceivePromotionalEmails = !merchantUser || canReceivePromotionalEmails !== merchantUser.canReceivePromotionalEmails;
          LoadingSpinner.show();
          try {
               authFormService.setRegistrationMail(emailAddress || userService.getUserEmail());
               authFormService.setConfirmationCodeType(DEFAULT_CONFIRMATION_CODE_TYPE);
               const newsletterIds = Object.keys(this.fields).filter(key => this.fields[key]);
               const response = await apiUserUpdateNewsletterSubscriptions({
                    emailAddress,
                    merchantId,
                    updateType: MerchantAudienceStore.all().length === 1
                        ? NewsletterSubscriptionUpdateType.SUBSCRIBE
                        : NewsletterSubscriptionUpdateType.REPLACE,
                    newsletterIds,
                    ...(updatedCanReceivePromotionalEmails && canReceivePromotionalEmails !== null ? {canReceivePromotionalEmails} : {}),
               });
               sendFlowCheckpoint(FLOW_TYPE.newsletter, FLOW_CHECKPOINT.complete, {
                    newsletterIds,
                    canReceivePromotionalEmails,
               }, {
                    audienceMembers: MerchantAudienceMemberStore
                        .loadFromResponse(response)
                        .map(audienceMember => ({
                             id: audienceMember.id,
                             merchantId: audienceMember.merchantId,
                             audienceId: audienceMember.audienceId,
                             userId: audienceMember.userId,
                             status: audienceMember.status,
                             subscribedAt: audienceMember.subscribedAt ? audienceMember.subscribedAt.format() : null,
                             unsubscribedAt: audienceMember.unsubscribedAt ? audienceMember.unsubscribedAt.format() : null,
                        })) ?? [],
               });
               Router.changeURL(INLINE_NEWSLETTER_URLS.success);
          } catch (error) {
               if (error.code === ApiErrors.PERMISSION_DENIED) {
                    try {
                         // TODO @cleanup reimplement this in a general way?
                         await authService.requestLoginCode({
                              email: authFormService.registrationMail,
                              secure: authFormService.confirmationCodeType === CONFIRMATION_CODE_TYPES.LONG,
                         });
                         Router.changeURL(LOGIN_WITH_EMAIL_CODE_URL);
                         authService.executeWhenAuthenticated(() => this.subscribeToNewsletter(emailAddress, canReceivePromotionalEmails));
                    } catch (innerError) {
                         Toast.showError(innerError);
                    }
               } else {
                    Toast.showError(error);
               }
          } finally {
               LoadingSpinner.hide();
          }
     }
}
